import { render, staticRenderFns } from "./caseInfo.vue?vue&type=template&id=9646efba&scoped=true"
import script from "./caseInfo.vue?vue&type=script&lang=js"
export * from "./caseInfo.vue?vue&type=script&lang=js"
import style0 from "./caseInfo.vue?vue&type=style&index=0&id=9646efba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9646efba",
  null
  
)

export default component.exports